import * as constans from './constans'
import axios from 'axios'

export const addNumberCreator = (payload: any) => ({
  type: constans.ADD_NUMBER,
  payload
})

export const minusNumberCreator = (payload: any) => ({
  type: constans.MINUS_NUMBER,
  payload
})

export const updateUserCreator = (payload: any) => ({
  type: constans.UPDATE_USER,
  payload
})

export const deleteUserCreator = (payload: any) => ({
  type: constans.DELETE_USER,
  payload
})

export const addrCreator = (payload: any) => ({
  type: constans.ADD,
  payload
})

export const minusCreator = (payload: any) => ({
  type: constans.MINUS,
  payload
})

export const updateArr = (payload: any) => ({
  type: constans.UPDATE,
  payload
})

export const delayCreator = () => {
  return async function (dispatch: any) {
    const ret = await axios.get('/api/demo')
    console.log(ret.data)
    dispatch(updateArr(ret.data))
  }
}
